import { NeutralColorToken, TextButton } from '@robinhood/design';

const Icon: React.ComponentProps<typeof TextButton>['icon'] = {
  type: 'LinkOut16',
  side: 'end',
};

interface PropsIface {
  label: string;
  href: string;
}

const LinkButton = ({ label, href }: PropsIface) => {
  return (
    <TextButton
      variant='standalone'
      type='anchor'
      label={label}
      href={href}
      target='_blank'
      icon={Icon}
      color={NeutralColorToken.Fg1}
    />
  );
};

export default LinkButton;
